<script>
import PayoutForm from './payoutForm';

export default {
   name: "PayoutEditFormModal",
   components: { PayoutForm },
   data() {
      return {
         dataToEdit: {}
      }
   },
   methods: {
      populateEditForm(dataToEditFromButton) {
         this.dataToEdit = dataToEditFromButton
         this.$bvModal.show('show-payout-edit-form-modal')
      },
      closeEditFormModal() {
         this.$bvModal.hide('show-payout-edit-form-modal');
         this.$emit('reloadPayoutList');
      }
   }
}
</script>
<template>
   <b-modal id="show-payout-edit-form-modal" centered hide-footer no-close-on-backdrop size="lg" class="mb-4">
      <template #modal-header>
         <div>
            <h5 class="font-weight-bold"> {{ $t('admin_page.payout_modal.edit_title') }} </h5>
         </div>
      </template>
      <PayoutForm :isEditMode="true" :dataToEdit="this.dataToEdit" @closeEditFormModal="closeEditFormModal"/>
   </b-modal>
</template>